export default __webpack_public_path__ + "static/pdf-download-e23884162032f2a0e9fe575be1c7f34d.png";